<template>
  <div class="icon">
    <swiper :options="swiperOption">
      <swiper-slide v-for="(page, index) in pages" :key="index">
        <div class="icons" v-for="icon in page" :key="icon.id">
          <div class="icon-img">
            <img :src="icon.imgUrl" alt="icon">
          </div>
          <p class="icon-desc">{{icon.desc}}</p>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'HomeIcons',
  data () {
    return {
      swiperOption: {
        autoplay: false
      }
    }
  },
  props: {
    list: Array
  },
  computed: {
    pages () {
      const pages = []
      this.list.forEach((item, index) => {
        const page = Math.floor(index / 8)
        if (!pages[page]) {
          pages[page] = []
        }
        pages[page].push(item)
      })
      return pages
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/variables.styl'
@import '~styles/mixin.styl'
.icon >>> .swiper-container
  height: 0
  padding-bottom: 50%
.icons
  position: relative
  overflow: hidden
  float: left
  height: 0
  width: 25%
  padding-bottom: 25%
  .icon-img
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: .44rem
    box-sizing: border-border-box
    padding: .1rem
    img
      display: block
      margin: 0 auto
      height: 100%
  .icon-desc
    position: absolute
    left: 0
    right: 0
    bottom: 0
    height: .44rem
    line-height: .44rem
    color: $darkTextColor
    text-align: center
    ellipsis()
</style>



// WEBPACK FOOTER //
// src/pages/home/components/icons.vue